var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGs1MexicoLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 896.70947,
    height: 512.48761,
    viewBox: "0 0 896.70944 512.48761",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,609.449 H 793.701 V 0 H 0 Z",
    id: "path16"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,-81.880405,661.82651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(445.1543,304.4869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-105.968 -85.939,-191.855 -191.855,-191.855 -105.992,0 -191.889,85.887 -191.889,191.855 0,105.972 85.897,191.883 191.889,191.883 C -85.939,191.883 0,105.972 0,0",
    style: {
      fill: "#102c66",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(292.3877,362.2799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -28.731,0 -49.587,-23.29 -49.587,-55.37 v -1.281 c 0,-32.928 19.859,-55.057 49.414,-55.057 16.421,0 28.721,6.718 36.365,12.604 v 47.412 H -0.94 v -12.174 h 23.682 v -28.033 l -0.898,-0.637 C 16.126,-96.568 8.397,-98.88 0.632,-98.88 c -21.016,0 -35.15,17.17 -35.15,42.715 v 0.964 c 0,24.375 14.382,42.064 34.195,42.064 11.542,0 18.77,-4.229 24.628,-9.156 l 8.514,11.345 C 23.107,-3.289 13.179,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(348.8193,265.1129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 10.976,-9.545 23.687,-14.377 37.826,-14.377 20.59,0 34.414,12.225 34.414,30.405 0,14.868 -7.916,23.323 -29.221,31.514 -19.416,7.514 -24.721,12.127 -24.721,21.475 0,9.094 7.63,15.326 18.555,15.326 8.051,0 16.42,-3.27 24.879,-9.721 l 8.127,10.975 C 60.587,93.167 49.644,97.008 37.334,97.008 17.54,97.008 3.71,84.91 3.71,67.576 3.71,50.2 14.658,42.854 34.859,35.262 52.24,28.847 57.826,23.897 57.826,14.91 c 0,-9.848 -8.164,-16.623 -19.842,-16.623 -12.809,0 -22.339,6.354 -29.371,12.436 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(459.5918,251.1236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 67.454 V 13.344 H 43.3 v 98.07 H 31.673 L -0.323,98.613 2.62,84.475 27.397,94.408 V 13.344 H 0 Z",
    style: {
      fill: "#102c66",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(419.8906,463.443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 2.012,0 3.115,0.997 3.115,2.512 3.115,4.117 1.903,5.015 0,5.015 H -3.828 V 0 Z m -8.263,8.851 h 8.562 c 4.211,0 7.346,-1.918 7.346,-6.035 0,-2.914 -1.611,-4.828 -4.029,-5.642 L 8.243,-9.367 H 2.919 l -3.93,5.737 h -2.817 v -5.737 h -4.435 z m 21.98,-9.459 v 0.103 c 0,8.121 -6.321,14.802 -14.728,14.802 -8.308,0 -14.718,-6.784 -14.718,-14.905 v -0.085 c 0,-8.14 6.306,-14.821 14.718,-14.821 8.319,0 14.728,6.774 14.728,14.906 m -33.48,-0.113 v 0.113 c 0,10.241 8.295,18.863 18.752,18.863 10.559,0 18.751,-8.524 18.751,-18.76 v -0.103 c 0,-10.246 -8.29,-18.864 -18.751,-18.864 -10.564,0 -18.752,8.515 -18.752,18.751",
    style: {
      fill: "#102c66",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(100.5742,304.4869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,87.516 67.342,159.283 153.047,166.348 l -0.276,0.598 h -0.046 C 60.512,166.946 -14.222,92.194 -14.222,0 c 0,-92.185 74.734,-166.91 166.947,-166.91 h 0.046 l 0.276,0.598 C 67.342,-159.256 0,-87.507 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(137.8994,304.4869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,73.48 55.842,133.903 127.423,141.159 l -0.337,0.711 C 49.877,140.522 -12.286,77.532 -12.286,0 c 0,-77.514 62.163,-140.485 139.372,-141.842 l 0.337,0.725 C 55.842,-133.87 0,-73.472 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(173.606,304.4957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,59.988 45.133,109.393 103.301,116.218 l -0.361,0.763 C 39.781,115.259 -10.882,63.562 -10.882,0 c 0,-63.562 50.663,-115.24 113.822,-116.971 l 0.361,0.772 C 45.133,-109.373 0,-59.987 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(207.9175,304.4957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,46.93 35.182,85.616 80.615,91.184 l -0.304,0.655 C 30.682,90.539 -9.142,49.938 -9.142,0 c 0,-49.929 39.824,-90.519 89.453,-91.819 l 0.304,0.654 C 35.182,-85.606 0,-46.93 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(460.6396,169.5728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 13.428 L 28.301,-23.93 43.178,0 H 56.601 V -56.595 H 44.23 v 36.95 L 28.301,-43.823 H 27.978 L 12.211,-19.888 V -56.595 H 0 Z",
    style: {
      fill: "#ea5929",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(551.9873,175.3932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 10.592,-4.608 0.079,-14.312 h -9.053 z m 5.174,-37.353 c -0.725,5.498 -3.963,9.221 -9.137,9.221 -5.09,0 -8.407,-3.639 -9.376,-9.221 z m -30.56,-3.635 v 0.159 c 0,12.37 8.81,22.559 21.423,22.559 14.476,0 21.105,-11.237 21.105,-23.532 0,-0.964 -0.08,-2.096 -0.163,-3.228 H -13.18 c 1.217,-5.581 5.095,-8.491 10.593,-8.491 4.126,0 7.115,1.295 10.507,4.449 l 7.037,-6.233 c -4.043,-5.006 -9.862,-8.084 -17.703,-8.084 -13.016,0 -22.64,9.142 -22.64,22.401",
    style: {
      fill: "#ea5929",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(593.209,143.6217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 8.169,12.688 H 21.021 L 6.387,-8.491 21.671,-30.644 H 8.487 l -8.73,13.502 -8.73,-13.502 h -12.856 l 15.2,21.989 -14.635,21.343 h 13.18 z",
    style: {
      fill: "#ea5929",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 621.982,156.31 h 12.29 v -43.332 h -12.29 z m -0.323,15.692 h 12.936 v -10.92 h -12.936 z",
    style: {
      fill: "#ea5929",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(642.9131,134.4049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0.159 c 0,12.37 9.46,22.56 22.719,22.56 8.169,0 13.259,-2.751 17.305,-7.28 L 32.502,7.354 c -2.747,2.911 -5.498,4.773 -9.862,4.773 -6.143,0 -10.508,-5.418 -10.508,-11.809 V 0.159 c 0,-6.63 4.28,-11.968 10.994,-11.968 4.122,0 6.952,1.779 9.942,4.614 l 7.196,-7.281 C 36.063,-19.083 31.211,-22.4 22.56,-22.4 9.54,-22.4 0,-12.369 0,0",
    style: {
      fill: "#ea5929",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74",
    transform: "translate(721.8154,134.4049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0.159 c 0,6.391 -4.607,11.968 -11.4,11.968 -7.033,0 -11.239,-5.418 -11.239,-11.809 V 0.159 c 0,-6.386 4.609,-11.968 11.402,-11.968 C -4.205,-11.809 0,-6.391 0,0 m -34.766,0 v 0.159 c 0,12.454 10.027,22.56 23.529,22.56 13.418,0 23.364,-9.947 23.364,-22.401 V 0.159 C 12.127,-12.29 2.101,-22.4 -11.4,-22.4 c -13.423,0 -23.366,9.946 -23.366,22.4",
    style: {
      fill: "#ea5929",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGs1MexicoLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gs1_mexico_logo.925448790bee3615b53ec874798888ee.svg";